export default __webpack_public_path__ + "static/media/grid-3x3-gap-fill.d87c0c96.svg";